import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

// @mui material components
import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import Checkbox from '@mui/material/Checkbox';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDInput from 'components/MDInput';
import MDDateRange from 'components/MDDateRange';
import TableHeader from 'components/Table/TableHeader';

// Material Dashboard 2 PRO React examples
import Navbar from 'examples/Navbars/NavBar';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import * as Func from 'services/Function';

const initFind = {
  search: '',
  page: 1,
  perPage: 10,
  pageTotal: 0,
  period: 'ALL',
  branch: [],
  cashier: 'ALL',
  date_start: Func.dateTimeFirstMonth(),
  date_stop: Func.dateTimeEndMonth(),
};

function RpDayEnd() {
  const mod = 'rp_dayend';
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [pageTotal, setPageTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [record, setRecord] = useState([]);
  const [show, setShow] = useState(null);
  const [find, setFind] = useState(initFind);
  const [loading, setLoading] = useState(true);
  const [cboCashier, setCboCashier] = useState([]);
  const [cboBranch, setCboBranch] = useState([]);
  const [urlExcel, setUrlExcel] = useState('');

  const openShow = (e) => setShow(e.currentTarget);
  const closeShow = () => setShow(null);

  const initHeader = [
    { id: 'code', label: 'ปิดรอบ', align: 'left', sort: false },
    { id: 'shift_code', label: 'รอบ', align: 'left', sort: false },
    { id: 'date_record', label: 'วันที่ขาย', align: 'left', sort: false },
    { id: 'user_name', label: 'แคชเชียร์', align: 'left', sort: false },
    { id: 'cashier_name', label: 'pos', align: 'left', sort: false },
    { id: 'ar_code', label: 'CUSID', align: 'left', sort: false },
    { id: 'branch_name', label: 'สาขา', align: 'left', sort: false },
    { id: 'status_name', label: 'สถานะ', align: 'left', sort: false },
    { id: 'tid', label: 'tid', align: 'left', sort: false },
    { id: 'first_bill', label: 'บิลแรก', align: 'left', sort: false },
    { id: 'last_bill', label: 'บิลสุดท้าย', align: 'left', sort: false },
    { id: 'money_start', label: 'เงินทอนเริ่มต้น', align: 'right', sort: false },
    { id: 'money_receive', label: 'เงินทอนปิดรอบ', align: 'right', sort: false },
    { id: 'nettotal', label: 'ยอดขาย', align: 'right', sort: false },
    { id: 'credit_card_fee', label: 'ค่าธรรมเนียมบัตรเครดิต', align: 'right', sort: false },
    { id: 'grand_total', label: 'รวมยอดขายและค่าธรรมเนียม', align: 'right', sort: false },
    { id: 'money_cash', label: 'เงินสดในระบบ', align: 'right', sort: false },
    { id: 'total_cash', label: 'เงินสดนำส่ง', align: 'right', sort: false },
    { id: 'pos_drop', label: 'ยอดดรอปเงิน', align: 'right', sort: false },
    { id: 'wallet_diff', label: 'ส่วนต่างเงินสด', align: 'right', sort: false },
    { id: 'money_transfer', label: 'เงินโอนในระบบ', align: 'right', sort: false },
    { id: 'total_transfer', label: 'เงินโอนนำส่ง', align: 'right', sort: false },
    { id: 'transfer_diff', label: 'ส่วนต่างเงินโอน', align: 'right', sort: false },
    { id: 'total_visa', label: 'Visa ในระบบ', align: 'right', sort: false },
    { id: 'total_count_visa', label: 'Visa นำส่ง', align: 'right', sort: false },
    { id: 'total_diff_visa', label: 'ส่วนต่าง Visa', align: 'right', sort: false },
    { id: 'total_mastercard', label: 'MasterCard ในระบบ', align: 'right', sort: false },
    { id: 'total_count_mastercard', label: 'MasterCard นำส่ง', align: 'right', sort: false },
    { id: 'total_diff_mastercard', label: 'ส่วนต่าง MasterCard', align: 'right', sort: false },
    { id: 'total_alipay', label: 'Alipay ในระบบ', align: 'right', sort: false },
    { id: 'total_count_alipay', label: 'Alipay นำส่ง', align: 'right', sort: false },
    { id: 'total_diff_alipay', label: 'ส่วนต่าง Alipay', align: 'right', sort: false },
    { id: 'total_wechat', label: 'Wechat ในระบบ', align: 'right', sort: false },
    { id: 'total_count_wechat', label: 'Wechat นำส่ง', align: 'right', sort: false },
    { id: 'total_diff_wechat', label: 'ส่วนต่าง Wechat', align: 'right', sort: false },
    { id: 'total_jcb', label: 'JCB ในระบบ', align: 'right', sort: false },
    { id: 'total_count_jcb', label: 'JCB นำส่ง', align: 'right', sort: false },
    { id: 'total_diff_jcb', label: 'ส่วนต่าง JCB', align: 'right', sort: false },
    { id: 'total_thai_payment', label: 'Thaipayment ในระบบ', align: 'right', sort: false },
    { id: 'total_count_thai_payment', label: 'Thaipayment นำส่ง', align: 'right', sort: false },
    { id: 'total_diff_thai_payment', label: 'ส่วนต่าง Thaipayment', align: 'right', sort: false },
    { id: 'total_union_pay', label: 'UnionPay ในระบบ', align: 'right', sort: false },
    { id: 'total_count_union_pay', label: 'UnionPay นำส่ง', align: 'right', sort: false },
    { id: 'total_diff_union_pay', label: 'ส่วนต่าง UnionPay', align: 'right', sort: false },
  ];

  const view = (data) => {
    setFind(data);
    setLoading(true);
    closeShow();

    FetchData('POST', `/${mod}`, app.token, {
      lang: app.lang,
      search: data.search,
      page: data.page,
      per_page: data.perPage,
      date_start: data.date_start,
      date_stop: data.date_stop,
      branch: data.branch,
      cashier: data.cashier,
    }).then((result) => {
      if (result.status === 'ok') {
        setRecord(result.data);
        setPageTotal(result.total_pages);
        setPageNo(result.page);
      }
      setLoading(false);
    });
  };

  const setDateRange = (start, stop) => {
    if (find.branch.length > 0) {
      view({
        ...find,
        date_start: Func.dateTimeFormat(start.toDate()),
        date_stop: Func.dateTimeFormat(stop.toDate()),
        page: 1,
      });
    }
  };

  const excel = () => {
    const params = new URLSearchParams();
    params.append('date_start', find.date_start);
    params.append('date_stop', find.date_stop);
    params.append('cashier', find.cashier);
    find.branch.forEach((branchId) => {
      params.append('branch[]', branchId);
    });

    window.open(`${urlExcel}/download?${params.toString()}`, '_self');
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  };

  const renderShow = (
    <Menu
      anchorEl={show}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      open={Boolean(show)}
      onClose={closeShow}
      keepMounted
    >
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 10 })}>
        {t(`element.show_record`, { num: 10 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 20 })}>
        {t(`element.show_record`, { num: 20 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 100 })}>
        {t(`element.show_record`, { num: 100 })}
      </MenuItem>
    </Menu>
  );

  const init = () => {
    FetchData('GET', `/${mod}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setCboBranch(result.branch);
        setCboCashier(result.cashier);
        setUrlExcel(result.excel);
        view({ ...find, branch: [] });
      } else {
        Func.exitApp();
      }
    });
  };

  const renderSearch = () => {
    return (
      <Card sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={3}>
            <MDInput
              fullWidth
              value={find.cashier}
              defaultValue='ALL'
              select
              onChange={(e) => view({ ...find, cashier: e.target.value, page: 1 })}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>{t('menu.cashier')} :</InputAdornment>
                ),
              }}
            >
              <MenuItem value='ALL'>{t('element.all')}</MenuItem>
              {cboCashier.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </MDInput>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <MDInput
              select
              fullWidth
              SelectProps={{
                multiple: true,
                renderValue: (selected) => {
                  if (selected.length === cboBranch.length) return 'ทั้งหมด';
                  return cboBranch
                    .filter((item) => selected.includes(item.id))
                    .map((item) => item.name)
                    .join(', ');
                },
              }}
              value={find.branch}
              onChange={(e) => {
                const { value } = e.target;

                if (value.includes('ALL')) {
                  const allSelected = find.branch.length === cboBranch.length;
                  view({
                    ...find,
                    branch: allSelected ? [] : cboBranch.map((item) => item.id),
                    page: 1,
                  });
                } else {
                  view({ ...find, branch: value, page: 1 });
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>{t('menu.branch')} :</InputAdornment>
                ),
              }}
            >
              <MenuItem value='ALL'>
                <Checkbox checked={find.branch.length === cboBranch.length} />
                ทั้งหมด
              </MenuItem>
              {cboBranch.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  <Checkbox checked={find.branch.indexOf(item.id) > -1} />
                  {item.name}
                </MenuItem>
              ))}
            </MDInput>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={5}>
            <MDDateRange
              dateStart={find.date_start}
              dateStop={find.date_stop}
              callBack={setDateRange}
              closeDate={() => {
                if (find.branch.length > 0) {
                  view({ ...find, page: 1 });
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={1}>
            <MDBox display='flex' justifyContent='end' gap={1}>
              <MDButton variant='gradient' color='success' onClick={excel}>
                <Icon>table_view</Icon>&nbsp;Excel
              </MDButton>
            </MDBox>
          </Grid>
        </Grid>
      </Card>
    );
  };

  const renderList = () => {
    return (
      <MDBox mb={7}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3} md={2} lg={1}>
            <MDButton
              variant='contained'
              color='dark'
              size='large'
              fullWidth
              sx={{ pt: 1.6, pb: 1.6 }}
              href='/report_manage_branch'
            >
              <Icon>content_paste_search</Icon>
            </MDButton>
          </Grid>
          <Grid item xs={12} sm={9} md={10} lg={11}>
            {renderSearch()}
          </Grid>
          <Grid item xs={12}>
            <TableContainer component={Paper} sx={{ minHeight: 400 }}>
              <Table aria-label='datatable table'>
                <TableHeader data={initHeader} />
                <TableBody>
                  {record.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={initHeader.length} align='center'>
                        ไม่พบข้อมูล{find.branch.length === 0 ? 'กรุณาเลือกสาขา' : 'ในสาขาที่เลือก'}
                      </TableCell>
                    </TableRow>
                  ) : null}
                  {record.map((row) => (
                    <TableRow key={row.id} hover>
                      <TableCell align='left'>{row.code}</TableCell>
                      <TableCell align='left'>{row.shift_code}</TableCell>
                      <TableCell align='left'>{row.date_record}</TableCell>
                      <TableCell align='left'>{row.user_name}</TableCell>
                      <TableCell align='left'>{row.cashier_name}</TableCell>
                      <TableCell align='left'>{row.ar_code}</TableCell>
                      <TableCell align='left'>{row.branch_name}</TableCell>
                      <TableCell align='left'>{row.status_name}</TableCell>
                      <TableCell align='left'>{row.tid}</TableCell>
                      <TableCell align='left'>{row.first_bill}</TableCell>
                      <TableCell align='left'>{row.last_bill}</TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.money_start, 2)}</TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.money_receive, 2)}
                      </TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.nettotal, 2)}</TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.credit_card_fee, 2)}
                      </TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.grand_total, 2)}</TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.money_cash, 2)}</TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.total_cash, 2)}</TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.pos_drop, 2)}</TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.wallet_diff, 2)}</TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.money_transfer, 2)}
                      </TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.total_transfer, 2)}
                      </TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.transfer_diff, 2)}
                      </TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.total_visa, 2)}</TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.total_count_visa, 2)}
                      </TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.total_diff_visa, 2)}
                      </TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.total_mastercard, 2)}
                      </TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.total_count_mastercard, 2)}
                      </TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.total_diff_mastercard, 2)}
                      </TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.total_alipay, 2)}</TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.total_count_alipay, 2)}
                      </TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.total_diff_alipay, 2)}
                      </TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.total_wechat, 2)}</TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.total_count_wechat, 2)}
                      </TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.total_diff_wechat, 2)}
                      </TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.total_jcb, 2)}</TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.total_count_jcb, 2)}
                      </TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.total_diff_jcb, 2)}
                      </TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.total_thai_payment, 2)}
                      </TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.total_count_thai_payment, 2)}
                      </TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.total_diff_thai_payment, 2)}
                      </TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.total_union_pay, 2)}
                      </TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.total_count_union_pay, 2)}
                      </TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.total_diff_union_pay, 2)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12}>
            <Card sx={{ p: 2 }}>
              <MDBox display='flex' justifyContent='space-between' alignItems='flex-start'>
                <MDButton variant={show ? 'contained' : 'outlined'} color='dark' onClick={openShow}>
                  {t(`element.show_record`, { num: find.perPage })}&nbsp;
                  <Icon>keyboard_arrow_down</Icon>
                </MDButton>
                {renderShow}
                <Pagination
                  count={pageTotal}
                  variant='outlined'
                  color='secondary'
                  showFirstButton
                  showLastButton
                  page={pageNo}
                  onChange={(e, p) => view({ ...find, page: p })}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    init();
  }, [id]);

  return (
    <MDBox>
      <Navbar route={[t(`menu.report_manage_branch`), t(`menu.rp_dayend`)]} />
      {renderList()}
      {renderLoading()}
    </MDBox>
  );
}

export default RpDayEnd;
